import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Card, Space, Table } from 'antd';
import dayjs from "dayjs";
import { useDataStore } from "../../store";
import echarts from "../../themes/roma";
import { getIndustryData, data2Series } from "./modules/utils";
import { AllIndustryModule } from "./modules/AllIndustryModule";
import { FinancialDetailModule } from "./modules/FinancialDetailModule";
import { LeaseDetailModule } from "./modules/LeaseDetailModule";
import { UsuryDetailModule } from "./modules/UsuryDetailModule";
import './Overview.css';

export function Overview (){
    return <Space direction="vertical">
        <AllIndustryModule />
        <ChartsModule industry="Lease" title="租赁数据概览">
            <LeaseDetailModule />
        </ChartsModule>
        <ChartsModule industry="Usury" title="借贷数据概览">
            <UsuryDetailModule />
        </ChartsModule>
        <ChartsModule industry="Financial" title="消金数据概览">
            <FinancialDetailModule />
        </ChartsModule>
    </Space>
}

function ChartsModule ( props ){
    const ref = useRef();
    const chart = useRef();
    const categoryMonthly = useDataStore(state => state.categoryMonthly);
    const [selectedParty, setSelectedParty] = useState( null );

    useEffect(() => {
        if( categoryMonthly ){
            if( !chart.current ) {
                chart.current = echarts.init(ref.current, 'roma');
            }
            let data = getIndustryData( categoryMonthly, props.industry );
            const chartsOptions = data2Series(data, props.industry);
            chart.current.setOption( chartsOptions );
            chart.current.on('legendselectchanged', function (params) {
                setSelectedParty( params.name );
            });
        }
    }, [ categoryMonthly, props.industry ]);

    return <Card title={props.title}>
        {props.children}
        <div ref={ref} className="charts"></div>
        <ChartsTable industry={props.industry} selectedParty={selectedParty}></ChartsTable>
    </Card>
}

//表格展示详细数据
function ChartsTable ({ industry, selectedParty }){
    const riskItems = useDataStore(state => state.riskItems);
    const getOrderDetail = useDataStore(state => state.getOrderDetail);
    const [ riskData, setRiskData ] = useState([]);

    useEffect(() => {

        let industryMap = {
            'Lease': riskItems.leasePlatform,
            'Usury': riskItems.usuryPlatform,
            'Financial': riskItems.financialPlatform
        }

        let _riskData = _.entries(industryMap[ industry ]).map(([key, item]) => {
            return item.map( order => {
                return getOrderDetail(order);
            });
        });
        //查看全部数据或单个party数据
        _riskData = _.flatten(_riskData).filter(item => {
            return item && (item.PARTY === selectedParty || selectedParty === null || selectedParty === '月总支出');
        });
        //按时间倒序排列
        _riskData = _.sortBy(_riskData, item => {
            return dayjs(item.TIME_YMD).valueOf();
        }).reverse();

        setRiskData( _riskData );

    }, [ riskItems, industry, selectedParty ]);

    return <Table rowKey="ID" dataSource={riskData} columns={[
        { title: '时间', dataIndex: 'TIME_YMD', key: 'TIME_YMD', sorter: (a, b) => dayjs(a.TIME_YMD).diff(dayjs(b.TIME_YMD)) },
        { title: '交易说明', dataIndex: 'TYPE', key: 'TYPE', ellipsis: true},
        { title: '收/支', dataIndex: 'IE', key: '_IE' },
        { title: '交易方式', dataIndex: 'TRADING', key: 'TRADING' },
        { title: '金额', dataIndex: 'AMOUNT', key: 'AMOUNT' },
        { title: '交易对方', dataIndex: 'PARTY', key: 'PARTY' }
    ]} pagination={{ pageSize: 5, showSizeChanger: false }}>
    </Table>
}
